import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Problem from './components/Problem';
import Solution from './components/Solution';
import HowItWorks from './components/HowItWorks';
import Team from './components/Team';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Accessibility from './pages/Accessibility';
import Disclaimers from './pages/Disclaimers';
import SiteDisclaimers from './components/SiteDisclaimers';

function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Navigation />
      <main id="main-content" className="flex-1">
        <Hero />
        <About />
        <Features />
        <Problem />
        <Solution />
        <HowItWorks />
        <Team />
        <SiteDisclaimers />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/disclaimers" element={<Disclaimers />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
